import React, { useEffect, useState } from 'react'
import { getCookie } from 'utils/cookies'
import useFeatureToggles from 'utils/hooks/use-feature-toggles'
import { sendMessageToApp } from 'utils/react-native-webview'

function HydrateFeatureToggles() {
  const { featureToggles, isLoadingFeatureTogglesData } = useFeatureToggles()

  useEffect(() => {
    if (isLoadingFeatureTogglesData) return

    sendMessageToApp({
      type: 'feature_flags',
      data: {
        seedPrPoc: featureToggles.seedPrPoc === true
      }
    })
  }, [featureToggles.seedPrPoc, isLoadingFeatureTogglesData])

  return null
}

export function FeatureTogglesHydrator() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = getCookie('access_token')
    return token !== null && token !== ''
  })

  useEffect(() => {
    if (isAuthenticated) {
      return
    }
    const id = setInterval(() => {
      const token = getCookie('access_token')
      if (token) {
        setIsAuthenticated(true)
      }
    }, 1000)
    return () => clearInterval(id)
  }, [isAuthenticated])

  if (!isAuthenticated) {
    return null
  }

  return <HydrateFeatureToggles />
}

export default FeatureTogglesHydrator
